import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import { useAuth } from '../../containers/UseAuth';
import { useService } from '../../containers/UseService';
import Modal from '../Modal/Modal';
import ModalHeader from '../Modal/ModalHeader/ModalHeader';
import ModalBody from '../Modal/ModalBody/ModalBody';
import ModalFooter from '../Modal/ModalFooter/ModalFooter';
import CommonButton from '../Buttons/CommonButton';

function WizardTab({
    calculatingForecast,
    step,
    canLaunchCampaign,
    isLaunching,
    onStepChange,
    stepIndex,
    canManageExpectedStats = false,
}) {
    const { t } = useTranslation();
    const creativesIndex = canManageExpectedStats ? 5 : 4;
    const reviewIndex = creativesIndex + 1;

    const handleStep = (name) => {
        if (calculatingForecast === false) {
            const blockWhileLaunching = [
                'basics',
                'location',
                'screens',
                'audiences',
                'expectedStats',
                'creatives',
                'review',
            ];

            if (isLaunching && blockWhileLaunching.includes(name)) {
                return;
            } else {
                onStepChange(name);
            }
        }
    };

    return (
        <div className="tabCampaignContainer top shadow-md ml-16">
            <div className="w-full flex justify-start overflow-x-auto scrollbar-thin scrollbar-black md:px-5 gap-4">
                <div className="h-8 w-8 pointer-events-none absolute top-0 left-0 ml-2 mt-1 z-10 bg-gradient-to-r from-gray-100"></div>
                <div className="h-8 w-8 pointer-events-none absolute top-0 right-0 mt-1 z-10 bg-gradient-to-l from-gray-100"></div>

                <div
                    className={`tabCampaign  ${step === 'basics' ? 'active' : ''
                        } ${stepIndex > 0 ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                    <div>
                        <Icon
                            name={stepIndex > 0 ? 'check-double' : 'pen'}
                            className={`text-xs align-top`}
                        />
                    </div>
                    <div>
                        {t('sections.campaigns.new-campaign.wizard-tab.basics')}
                    </div>
                </div>

                <div
                    className={`tabCampaign ${step === 'location' ? 'active' : ''
                        } ${stepIndex > 1 ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                    <div>
                        <Icon
                            name={stepIndex > 1 ? 'check-double' : 'map-marker'}
                            className={`text-xs align-top`}
                        />
                    </div>
                    <div>
                        {t('sections.campaigns.new-campaign.wizard-tab.location')}
                    </div>
                </div>
                <div
                    className={`tabCampaign ${step === 'screens' ? 'active' : ''
                        } ${stepIndex > 2 ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                    <div>
                        <Icon
                            name={stepIndex > 2 ? 'check-double' : 'sign'}
                            className={`text-xs align-top`}
                        />
                    </div>
                    <div>
                        {t('sections.campaigns.new-campaign.wizard-tab.screens')}
                    </div>
                </div>
                <div
                    className={`tabCampaign ${step === 'audiences' ? 'active' : ''
                        } ${stepIndex > 3 ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                    <div>
                        <Icon
                            name={stepIndex > 3 ? 'check-double' : 'users-class'}
                            className={`text-xs align-top`}
                        />
                    </div>
                    <div>
                        {t('sections.campaigns.new-campaign.wizard-tab.audiences')}
                    </div>
                </div>
                {canManageExpectedStats && (
                    <div
                        className={`tabCampaign ${step === 'expectedStats' ? 'active' : ''
                            } ${stepIndex > 4 ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                        <div>
                            <Icon
                            name={stepIndex > 4 ? 'check-double' : 'chart-line'}
                            className={`text-xs align-top`}
                        />
                        </div>
                        <div>
                            {t('sections.campaigns.new-campaign.wizard-tab.expectedStats')}
                        </div>
                    </div>
                )}
                <div
                    className={`tabCampaign ${step === 'creatives' ? 'active' : ''
                        } ${stepIndex > creativesIndex ? 'text-green-500' : 'text-gray-400'}
                        flex flex-row gap-1`}>
                    <div>
                        <Icon
                            name={stepIndex > creativesIndex ? 'check-double' : 'palette'}
                            className={`text-xs align-top`}
                        />
                    </div>
                    <div>
                        {t('sections.campaigns.new-campaign.wizard-tab.creatives')}
                    </div>
                </div>
                <div
                    className={`tabCampaign ${step === 'review' ? 'active' : ''
                        } ${stepIndex > reviewIndex ? 'text-green-400' : 'text-gray-400'}`}>
                    <Icon
                        name="clipboard-check"
                        className={`${step !== 'review' ? 'opacity-50' : 'opacity-100'
                            } mr-1  text-xs`}
                    />{' '}
                    {t('sections.campaigns.new-campaign.wizard-tab.review')}
                </div>
            </div>
        </div>
    );
}

export default WizardTab;
